export const isFullStatic = false
export const staticPath = "/root/project/frontend/.nuxt/static-json"
export const publicPath = "https://frontenddev.builtin.com/379cd7f1f6b35d1e12d9e20d4c8237231be04eec/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"